import { render, staticRenderFns } from "./LLSpoilerWrapper.vue?vue&type=template&id=40170c2c&scoped=true"
import script from "./LLSpoilerWrapper.vue?vue&type=script&lang=js"
export * from "./LLSpoilerWrapper.vue?vue&type=script&lang=js"
import style0 from "./LLSpoilerWrapper.vue?vue&type=style&index=0&id=40170c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40170c2c",
  null
  
)

export default component.exports